module.exports = __webpack_public_path__ + "img/icon-wallet.4340fea0.svg";